import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginService } from "../login/services";
import useUserStore from "../../store/user";
import { Page } from "../../components/page-base";
import { toast } from "react-toastify";
import {
  getOAuthRedirectPath,
  normalizeCurrentUserResponse,
  normalizeOAuthUserType,
} from "./oauth-callback-utils";
import { destinoDepoisDoLogin } from "../../utils/acesso-ao-relatorio";

export const GoogleCallbackPageAdm: React.FC = () => {
  const { setUser, setProfiles, setProfileAccesses } = useUserStore();
  const location = useLocation();
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    const handleAuthCallback = async () => {
      if (handledRef.current) {
        return;
      }
      handledRef.current = true;

      const params = new URLSearchParams(location.search);
      const code = params.get("code");

      if (!code) {
        toast.error("Código de autorização do Google não encontrado.");
        navigate("/login");
        return;
      }

      const token = await LoginService.finishGoogleOAuth(code);
      if (!token) {
        navigate("/login");
        return;
      }

      const meData = await LoginService.getCurrentUser(token);
      if (!meData) {
        navigate("/login");
        return;
      }

      const currentUser = normalizeCurrentUserResponse(meData);
      const businessProfiles = currentUser.businessProfiles ?? [];
      const profileAccesses = currentUser.profileAccesses ?? [];
      const userType = normalizeOAuthUserType(currentUser.userType);

      setUser({
        name: currentUser.name ?? "",
        token,
        userType,
        businessProfiles,
        profileAccesses,
      });
      setProfiles(businessProfiles);
      setProfileAccesses(profileAccesses);

      navigate(
        destinoDepoisDoLogin() ??
          getOAuthRedirectPath({
            userType,
            businessProfiles,
          }),
      );
    };

    handleAuthCallback();
  }, [location.search, navigate, setProfiles, setProfileAccesses, setUser]);

  return (
    <Page.Root>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Page.Loader />
      </div>
    </Page.Root>
  );
};
